export class FgInspecReq{
    fgInspectionId: number;
}